export interface PhoneNumberPreview {
  id: number
  pbx_id: number
  name: string
  created_at: string
  updated_at: string
}

export interface PhoneNumber {
  id: number
  name: string
  number: string
  number_for_display: string
  is_primary_sms: boolean
}

export enum PhoneCallStatus {
  INITIAL = 'INITIAL',
  RINGING = 'RINGING',
  CONNECTED = 'CONNECTED',
  ENDING_CALL = 'ENDING_CALL',
  ENDED = 'ENDED',
}

export type PhoneCall = {
  status: PhoneCallStatus
  callUuid: string
  number: string
  name: string | null
  startTime: Date | null
  isOnHold: boolean
  isMuted: boolean
}
